// extracted by mini-css-extract-plugin
export default {"page":"NU","heading":"OU","subheading":"PU","flavorbox":"QU","inner":"RU","image":"SU","label":"TU","flavorselect":"UU","arrow":"VU","flavorswrap":"WU","flavorsheader":"XU","flavorsnav":"YU","flavorsinner":"ZU","cancelbtn":"aV","flavorsbottom":"bV","retakebtn":"cV","continueBtn":"eV","drawerinner":"fV","videowrap":"gV","flavorsbottomnav":"hV"};
    if(module.hot) {
      // 1715632478846
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  